import { defaultNotificationsSettings } from '@utils/notification';

import { PatientState } from './patient-store.types';

// ? Intended for future use when we want to have multi-patient devices
export const PATIENT_ID: number = 1;
export const STORE_NAME: string = 'PATIENT';

export const initialState: PatientState = {
  patientInfo: {
    id: PATIENT_ID,
    isLoggedIn: false,
    isSessionExpired: false,
    isPinMechanismActive: false,
    is2faActive: true,
    isAccountCreated: false,
    isAccountVerified: false,
    pinLockAttempts: 0,
    isConsentForTracking: true,
    isBirthdayHardcoded: false,
    hasNewNotification: false,
    notificationSettings: defaultNotificationsSettings,
  },
};
